import type { HttpError } from '@packages/domain/constants/http';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { otp } from 'services/payex/otp/otp';
import type {
  VerifyOtpParams,
  VerifyOtpResponse,
} from 'services/payex/otp/types';

const useVerifyOtp = (): UseMutationResult<
  VerifyOtpResponse,
  HttpError,
  VerifyOtpParams
> =>
  useMutation<VerifyOtpResponse, HttpError, VerifyOtpParams>({
    mutationKey: ['otp', 'verify'],
    mutationFn: params => otp.verify(params),
  });

export { useVerifyOtp };
